import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@material-ui/core';
import { GridSize } from '@material-ui/core/Grid';

import { PaddedPaper } from 'components';

interface IProps {
  icon: ReactNode;
  titleKey: string;
  subtitleKey: string;
  toggle: ReactNode;
  toggleColumns?: GridSize;
}

const WidgetContainer: FC<IProps> = ({
  icon,
  titleKey,
  subtitleKey,
  toggle,
  toggleColumns,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <PaddedPaper>
      <Grid container direction="column" wrap="nowrap" spacing={2}>
        <Grid item>
          <Grid container>
            <Grid item xs={1}>
              <Box mt={0.5}>{icon}</Box>
            </Grid>
            <Grid item container direction="column" xs>
              <Grid item>
                <Typography variant="subtitle1">{t(titleKey)}</Typography>
              </Grid>
              <Grid item>
                <Typography color="textSecondary">{t(subtitleKey)}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={toggleColumns}>
              {toggle}
            </Grid>
          </Grid>
        </Grid>
        {children && <Grid item>{children}</Grid>}
      </Grid>
    </PaddedPaper>
  );
};

WidgetContainer.defaultProps = {
  toggleColumns: 1,
};

export default WidgetContainer;
